import React from "react";
import { sanitize } from "dompurify";
import { Link } from "../../../constants/assets/containers";
import { Api } from "../../../services/config/request";

const InformationBar = ({
  instructions = [],
  sampleUrl,
  message = "Download Sample CSV",
}) => {
  const messageInfo = (
    <span>(Select the CSV Type to Enable Download Link)</span>
  );
  const downloadLink = (
    <Link download href={sampleUrl}>
      Click here
    </Link>
  );

  const customButtonStyle = {
    color: 'red',
    backgroundColor: 'transparent',
    textDecoration: 'none',
    border: 'none',
    padding: '0',
    cursor: 'pointer',
  };


  const downloadFile = async (e) => {
    
    try {
      const defaultHeaders = Api.headers();
  
      const headers = { ...defaultHeaders };
      delete headers['Content-Type'];
  
      const { blob, headers: responseHeaders } = await Api.download(sampleUrl, true, headers);
  
      let filename = sampleUrl.substring(sampleUrl.lastIndexOf('/') + 1);
      if (!filename || filename.trim() === '') {
        // If filename is not found or empty, use a default filename
        filename = 'downloaded_file.csv';
      }  
      // Create download URL
      const url = window.URL.createObjectURL(blob);
  
      // Create anchor element
      const a = document.createElement('a');
      a.href = url;
      a.download = filename; // Set the download filename
      document.body.appendChild(a);
  
      // Simulate click on anchor element to trigger download
      a.click();
  
      // Clean up
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('There was a problem with the download operation:', error);
    }
  };

  return (
    <div className="information-snippet">
      {instructions.length > 0 && (
        <React.Fragment>
          <p>Note:</p>
          <ul>
            {instructions.map((instruction) => (
              <li dangerouslySetInnerHTML={{ __html: sanitize(instruction) }} />
            ))}
          </ul>
        </React.Fragment>
      )}
      <div className="flex items-center">
        <h4 className="mr-10">{message}</h4>
        {sampleUrl.length > 0 ?  <button type="button" style={customButtonStyle} onClick={downloadFile}>
            Click here
          </button> : messageInfo}
      </div>
    </div>
  );
};

export default React.memo(InformationBar);